import BaseComponent from 'scripts/components/base-component'

class Warrant extends BaseComponent {
  static componentName = 'warrant-stamp'

  static emitterEvents = {
    'buybox:sellerChange': 'toggleWarrantStamp'
  }

  toggleWarrantStamp ({ shopId }) {
    const elem = this.$element[0]
    const hasClass = elem.classList.contains('hidden')
    const hasShopId = !!shopId

    if (hasShopId) {
      if (hasClass) {
        elem.classList.remove('hidden')
      }
    } else if (!hasClass) {
      elem.classList.add('hidden')
    }
  }
}

export default ($el) => new Warrant($el)

export { Warrant as Component }
